// extracted by mini-css-extract-plugin
export default {"fromContainer":"Login_fromContainer__T-anI","input":"Login_input__Ttyz7","errorUser":"Login_errorUser__9oXk8","errorPass":"Login_errorPass__YXxGZ","button":"Login_button__f0Tlw"};